import AppProvider from "./src/app/AppProvider";
import {
  initApollo,
  getApolloCache,
  getApolloClient,
  setConnectionInfo
} from "./src/graphql/index";
import {
  loginMutation,
  login,
  logoutMutation,
  logout,
  forgotPasswordMutation,
  forgotPassword,
  resetPasswordMutation,
  resetPassword,
  isMfaEnabledMutation,
  isMfaEnabled
} from "./src/query/Authentication";
import getConnectionInfoQuery from "./src/query/GetConnectionInfoQuery";
import hasPermissions from "./src/security";
import SecuredComponent from "./src/security/SecuredComponent";

export {
  AppProvider,
  initApollo,
  getApolloCache,
  getApolloClient,
  setConnectionInfo,
  loginMutation,
  login,
  logoutMutation,
  logout,
  forgotPasswordMutation,
  forgotPassword,
  resetPasswordMutation,
  resetPassword,
  isMfaEnabledMutation,
  isMfaEnabled,
  getConnectionInfoQuery,
  hasPermissions,
  SecuredComponent
};
